import * as React from "react";
import cs from "classnames";
import { Link } from "react-router-dom";
// UI Framework
import { Layout, Button } from "antd";
// Local components
import DropDown from "./components/Dropdown";
// Utilities
// import { getBaseDomain } from "helpers/index";
// Styles
import styles from "./index.module.scss";

const { Header: LayoutHeader } = Layout;

const Header: React.FC = () => {
	return (
		<LayoutHeader className={styles["dashboard-header"]}>
			<div className={cs(styles["dashboard-header__menu"], styles["menu"])}>
				<Link className={styles["menu__logo"]} to="/dashboard">
					<img src="/logotype.png" height="32" alt="Logo" />
				</Link>
				<Link className={styles["menu__increase-credit"]} to="/dashboard/deposit">
					<Button style={{ width: 140 }} className={styles["menu__btn-warning"]}>
						افزایش موجودی
					</Button>
				</Link>
				{/* <a
					className={styles["menu__exchange"]}
					href={`http://exchange${getBaseDomain()}/`}
					target="_blank"
					rel="noreferrer"
				>
					<Button style={{ width: 140 }} className={styles["menu__btn-primary"]}>
						ورود به تالار
					</Button>
				</a> */}
			</div>

			<div className={styles["graph-header"]}>
				<div className={styles["graph-header__sell"]}></div>
				<div className={styles["graph-header__buy"]}></div>
			</div>

			<DropDown />
		</LayoutHeader>
	);
};

export default Header;
